import _ from 'lodash'
import moment from 'moment'
import getFilteredEventsForCategories from './getFilteredEventsForCategories'
import getFilteredEventsForLocations from './getFilteredEventsForLocations'

function getFilteredEventsForDateRange(
  eventsData,
  activeCategories,
  activeLocations,
  activeStartDate,
  activeEndDate = null
) {
  let events = null
  let dailyEvents = []

  if (eventsData && eventsData.data && !_.isEmpty(eventsData.data.events)) {
    for (const eventKey in eventsData.data.events) {
      const currentEvent = eventsData.data.events[eventKey]
      if (currentEvent && currentEvent.title && currentEvent.schedule) {
        for (const scheduleKey in currentEvent.schedule) {
          const eventStartDate = _.get(currentEvent, `schedule[${scheduleKey}].startDate`)
          const isSameOrAfterStartDate = moment(eventStartDate).isSameOrAfter(
            activeStartDate,
            'day'
          )

          // There is no activeEndDate when the page is first loaded.
          // In this case, display all today and future events
          const isSameOrBeforeEndDate = activeEndDate
            ? moment(eventStartDate).isSameOrBefore(activeEndDate, 'day')
            : true

          if (isSameOrAfterStartDate && isSameOrBeforeEndDate) {
            const currentSchedule = currentEvent.schedule[scheduleKey]
            const startDate = _.get(currentSchedule, 'startDate', null)
            const endDate = _.get(currentSchedule, 'endDate', null)

            const formattedEvent = {
              ...currentEvent,
              activeDates: {
                startDate: startDate,
                endDate: endDate,
              },
            }

            dailyEvents.push(formattedEvent)
            events = dailyEvents
          }
        }
      }
    }

    if (!_.isEmpty(activeCategories) && !_.isEmpty(events)) {
      events = getFilteredEventsForCategories(events, activeCategories)
    }

    if (!_.isEmpty(activeLocations) && !_.isEmpty(events)) {
      events = getFilteredEventsForLocations(events, activeLocations)
    }
  }

  return events
}

export default getFilteredEventsForDateRange
